import { Component, Output, EventEmitter, ChangeDetectorRef, Input, ChangeDetectionStrategy } from '@angular/core';

import { GeoServices } from '../../../services/geo.service';
import { FormComponentI } from '../../../shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from '../../../shared/models/internal-state-event';
import { TranslateService } from 'ng2-translate';
import { LoginService } from 'nm-socle-application/app/components/login/login.service';
import { StateMiscArgument } from 'nm-socle-application/app/shared/models/customer-config';
import { TemplateInitService } from 'nm-socle-application/app/shared/services/template-init.service';
import { TemplateCurrentState, TemplateCurrentStateArgument } from 'nm-socle-application/app/shared/models/template-current-state';
import { LoginResultComponent } from 'nm-socle-application/app/components/login/login-result/login-result.component';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';

@Component({
    selector: 'ask-demo-access',
    templateUrl: './ask-demo-access.component.html',
    styleUrls: ['./ask-demo-access.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush,
})
export class AskDemoAccessComponent extends AbstractComponent implements FormComponentI {
    public static LOGIN_STATE:string = 'login';
    public static LOST_PASSWORD_STATE:string = 'lostPasswd';

    public email: string; // A changer
    public nom: string; // A changer
    public prenom:string; // A changer
    public cgvAccept:boolean = false; // A changer
    public cgvLabel:string = '';

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();

    @Input() public misc:StateMiscArgument[] = [];

    constructor(
        public geoServices: GeoServices,
        private _loginService:LoginService,
        protected _cd:ChangeDetectorRef,
        private _translateService:TranslateService,
        private _templateInitService: TemplateInitService,
    ) {
        super(_cd);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.internalStateEvent.emit(new InternalStateEvent({title: 'ask-demo.title'}));
        let url:string = this.getFromMisc('cgvUrl');
        let urlStart:string = '';
        let urlEnd:string = '';

        if(url != undefined) {
            urlStart = '<a href="'+url+'" target="_blank">';
            urlEnd = '</a>';
        }
        this.cgvLabel = this._translateService.instant('ask-demo.cgv.label', {urlStart: urlStart, urlEnd: urlEnd});
        this.markForCheck();
    }

    public onCheckBoxToggled(value) {
        this.cgvAccept = value.srcElement.checked;
    }

    public submitAskDemo() {
        let url:string = this.getFromMisc('url');
        let mailFrom:string = this.getFromMisc('mailFrom');
        let destMail:string = this.getFromMisc('destMail');
        let login:string = this.getFromMisc('login');
        let passwd:string = this.getFromMisc('pass');
        let signature:string = this.getFromMisc('signature');

        this._subs.push(this._loginService.askDemo(this.email, this.nom, this.prenom, mailFrom, destMail, url, login, passwd, signature).subscribe(
            res => {
                this._templateInitService.setCurrentState(new TemplateCurrentState({state: 'demo-result', args:[new TemplateCurrentStateArgument({name:'valid', value:res?LoginResultComponent.SUCCESS:LoginResultComponent.FAIL})]}));

                this.markForCheck();
            }
        ));

        this.markForCheck();
    }

    public getFromMisc(name:string):any {
        let res:any;

        for(let curMisc of this.misc) {
            if(curMisc.name == name) {
                res = curMisc.value;
                break;
            }
        }

        return res;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/components/ask-demo-access/ask-demo-access.component.ts